/**
 * @flow
 * @relayHash e617db9e3d3b549b792b4a8acbf47ae9
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type POStatus = "APPROVED" | "CANCELLED" | "PARTIALLY_RECEIVED" | "PENDING_APPROVAL" | "RECEIVED" | "REJECTED" | "SENT";
export type ReceivingInterfaceQueryVariables = {|
  id: string
|};
export type ReceivingInterfaceQueryResponse = {|
  +purchaseOrder: {|
    +id: string,
    +poNumber: string,
    +vendor: ?{|
      +id: string,
      +vendorNumber: string,
      +name: string,
      +email: ?string,
      +phone: ?string,
    |},
    +status: POStatus,
    +totalAmount: number,
    +expectedDeliveryDate: ?any,
    +lineItems: $ReadOnlyArray<{|
      +id: string,
      +item: {|
        +id: string,
        +itemNumber: string,
        +name: string,
        +lotTracking: ?boolean,
      |},
      +quantity: number,
      +quantityReceived: ?number,
      +unitPrice: number,
    |}>,
  |}
|};
export type ReceivingInterfaceQuery = {|
  variables: ReceivingInterfaceQueryVariables,
  response: ReceivingInterfaceQueryResponse,
|};
*/


/*
query ReceivingInterfaceQuery(
  $id: ID!
) {
  purchaseOrder(id: $id) {
    id
    poNumber
    vendor {
      id
      vendorNumber
      name
      email
      phone
    }
    status
    totalAmount
    expectedDeliveryDate
    lineItems {
      id
      item {
        id
        itemNumber
        name
        lotTracking
      }
      quantity
      quantityReceived
      unitPrice
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "id",
    "type": "ID!",
    "defaultValue": null
  }
],
v1 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "name",
  "args": null,
  "storageKey": null
},
v3 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "purchaseOrder",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      }
    ],
    "concreteType": "PurchaseOrder",
    "plural": false,
    "selections": [
      (v1/*: any*/),
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "poNumber",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "vendor",
        "storageKey": null,
        "args": null,
        "concreteType": "Vendor",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "vendorNumber",
            "args": null,
            "storageKey": null
          },
          (v2/*: any*/),
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "email",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "phone",
            "args": null,
            "storageKey": null
          }
        ]
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "status",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "totalAmount",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "expectedDeliveryDate",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "lineItems",
        "storageKey": null,
        "args": null,
        "concreteType": "PurchaseOrderLine",
        "plural": true,
        "selections": [
          (v1/*: any*/),
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "item",
            "storageKey": null,
            "args": null,
            "concreteType": "Item",
            "plural": false,
            "selections": [
              (v1/*: any*/),
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "itemNumber",
                "args": null,
                "storageKey": null
              },
              (v2/*: any*/),
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "lotTracking",
                "args": null,
                "storageKey": null
              }
            ]
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "quantity",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "quantityReceived",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "unitPrice",
            "args": null,
            "storageKey": null
          }
        ]
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "ReceivingInterfaceQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v3/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "ReceivingInterfaceQuery",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v3/*: any*/)
  },
  "params": {
    "operationKind": "query",
    "name": "ReceivingInterfaceQuery",
    "id": null,
    "text": "query ReceivingInterfaceQuery(\n  $id: ID!\n) {\n  purchaseOrder(id: $id) {\n    id\n    poNumber\n    vendor {\n      id\n      vendorNumber\n      name\n      email\n      phone\n    }\n    status\n    totalAmount\n    expectedDeliveryDate\n    lineItems {\n      id\n      item {\n        id\n        itemNumber\n        name\n        lotTracking\n      }\n      quantity\n      quantityReceived\n      unitPrice\n    }\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '806bc98a200acd3015c6662e3d09b999';
module.exports = node;
